import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import User from '@/views/User'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/resolusi-github',
      name: 'Home',
      component: Home
    },
    {
      path: '/resolusi-github/index.html',
      name: 'HomeIndex',
      component: Home
    },
    {
      path: '/resolusi-github/:username',
      name: 'User',
      component: User,
      params: true
    }
  ],
  mode: 'history'
})
